import { EvoLogoFull, DiscordIcon, MailIcon } from './icons'
import styles from './ReportFooter.module.css'

/**
 * Site footer — a faithful port of the evograding.com footer
 * (main.js: components ae/se/re/ee/ne/oe). Orange band, 24px padding,
 * max-width 1440 row that stacks on mobile; Figtree 600 / 12px / white.
 */
export function ReportFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.row}>
        <div className={styles.left}>
          <span className={styles.logo}>
            <EvoLogoFull height={30} />
          </span>
          <a
            className={styles.pill}
            href="https://discord.gg/XTxUgUAFJh"
            target="_blank"
            rel="noopener noreferrer"
          >
            <DiscordIcon size={18} />
            <span className={styles.pillText}>Join our Discord server</span>
          </a>
          <a className={styles.pill} href="mailto:hello@evograding.com">
            <MailIcon size={18} />
            <span className={styles.pillText}>hello@evograding.com</span>
          </a>
        </div>

        <div className={styles.right}>
          <div className={styles.links}>
            <a className={styles.link} href="https://evograding.com/support">
              Support
            </a>
            <a className={styles.link} href="https://evograding.com/privacy">
              Privacy
            </a>
            <a className={styles.link} href="https://evograding.com/terms">
              Terms
            </a>
          </div>
          <p className={styles.copyright}>© 2026 Evo Collectibles Inc.</p>
        </div>
      </div>
    </footer>
  )
}
